import React, { useState } from 'react';
import Overview      from './Overview';
import Subscriptions from './Subscriptions';
import Users         from './Users';
import Deals         from './Deals';
import Transactions  from './Transactions';
import Support       from './Support';

const TABS = [
  { id: 'overview',       label: 'Overview' },
  { id: 'subscriptions',  label: 'Subscriptions' },
  { id: 'users',          label: 'Users' },
  { id: 'deals',          label: 'Deals' },
  { id: 'transactions',   label: 'Transactions' },
  { id: 'support',        label: 'Support' },
];

export default function Admin() {
  const [tab, setTab] = useState('overview');

  return (
    <div className="p-6 max-w-6xl mx-auto">
      <h1 className="text-xl font-semibold text-slate-900 dark:text-white mb-5">Admin</h1>

      <div className="flex gap-1 mb-6 overflow-x-auto border-b border-slate-200 dark:border-slate-700">
        {TABS.map(t => (
          <button
            key={t.id}
            onClick={() => setTab(t.id)}
            className={`shrink-0 whitespace-nowrap px-4 py-2 text-sm font-medium border-b-2 -mb-px transition-colors ${
              tab === t.id
                ? 'border-blue-600 text-blue-600 dark:text-blue-400 dark:border-blue-400'
                : 'border-transparent text-slate-500 dark:text-slate-400 hover:text-slate-700 dark:hover:text-slate-200'
            }`}
          >
            {t.label}
          </button>
        ))}
      </div>

      {tab === 'overview'      && <Overview />}
      {tab === 'subscriptions' && <Subscriptions />}
      {tab === 'users'         && <Users />}
      {tab === 'deals'         && <Deals />}
      {tab === 'transactions'  && <Transactions />}
      {tab === 'support'       && <Support />}
    </div>
  );
}
